import {DiffLineType} from '@github-ui/diffs/types'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {StaticDiffLine} from '@github-ui/diff-lines/conversation-types'

/**
 * Escapes HTML special characters to prevent XSS
 */
function escapeHtml(text: string): string {
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  }
  return text.replace(/[&<>"']/g, m => map[m] ?? m)
}

/**
 * Parses a unified diff string into an array of StaticDiffLine objects
 * for rendering with StaticUnifiedDiffPreview
 */
export function parseUnifiedDiff(diffString: string): StaticDiffLine[] {
  const lines = diffString.split('\n')
  const diffLines: StaticDiffLine[] = []
  let leftLineNum = 0
  let rightLineNum = 0

  for (const line of lines) {
    if (line.startsWith('@@')) {
      const match = line.match(/@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@/)
      if (match && match[1] && match[2]) {
        leftLineNum = parseInt(match[1], 10)
        rightLineNum = parseInt(match[2], 10)
      }

      diffLines.push({
        type: DiffLineType.Hunk,
        left: null,
        right: null,
        html: escapeHtml(line),
        text: line,
      })
    } else if (line.startsWith('+') && !line.startsWith('+++')) {
      const content = line.slice(1)
      diffLines.push({
        type: DiffLineType.Addition,
        left: null,
        right: rightLineNum++,
        html: escapeHtml(content),
        text: content,
      })
    } else if (line.startsWith('-') && !line.startsWith('---')) {
      const content = line.slice(1)
      diffLines.push({
        type: DiffLineType.Deletion,
        left: leftLineNum++,
        right: null,
        html: escapeHtml(content),
        text: content,
      })
    } else if (line.startsWith(' ')) {
      const content = line.slice(1)
      diffLines.push({
        type: DiffLineType.Context,
        left: leftLineNum++,
        right: rightLineNum++,
        html: escapeHtml(content),
        text: content,
      })
    }
  }

  return diffLines
}
